__turbopack_context__.v({
  "cardLatest": "CardSmall-module-scss-module__fKzMLq__cardLatest",
  "cardLinkWrap": "CardSmall-module-scss-module__fKzMLq__cardLinkWrap",
  "cardSmall": "CardSmall-module-scss-module__fKzMLq__cardSmall",
  "copy": "CardSmall-module-scss-module__fKzMLq__copy",
  "icon": "CardSmall-module-scss-module__fKzMLq__icon",
  "inner": "CardSmall-module-scss-module__fKzMLq__inner",
  "largeIcon": "CardSmall-module-scss-module__fKzMLq__largeIcon",
});
